<template>
<div class="input-password">
    <input 
        ref="inputFieldRef"
        :value="modelValue"
        v-bind="$attrs"
        :type="getInputType"
        @input="onFieldInput"
        @blur="onFieldBlur"
        @focus="emit('focus', $event)"
    >
    <transition name="fade" mode="out-in">
        <div v-if="showIcon" :class="getIconCls" @click.stop.prevent="onReveal" :title="getIconTitle" role="button">
            <svg v-if="revealPass" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32"
                overflow="visible" xml:space="preserve">
                <path d="M22.7,16.1c0-3.7-3-6.7-6.7-6.7c-0.3,0-0.7,0-1,0.1l7.6,7.6C22.7,16.8,22.7,16.5,22.7,16.1z" />
                <path d="M31.4,15.7C27.9,9.8,22.9,6.1,16,6.1c-1.4,0-2.7,0.2-4,0.5L13.5,8c0.8-0.1,1.7-0.2,2.5-0.2c6.1,0,10.4,3.2,13.6,8.3
                    c-1.1,1.7-2.3,3.2-3.6,4.4l1.2,1.2c1.6-1.4,2.9-3.2,4.1-5.2v0C31.5,16.3,31.5,16,31.4,15.7z" />
                <path d="M24.5,21.9l-2.5-2.5l-9.1-9.1l-1.7-1.7L9.8,7.2L5.1,2.5L5,2.7L3.7,3.9l4.2,4.2C5,9.8,2.6,12.4,0.6,15.7
                    c-0.2,0.3-0.2,0.6,0,0.9c3.5,5.9,8.5,9.6,15.4,9.6c3,0,5.7-0.7,8-2l5.1,5.1l1.4-1.4l-4.8-4.8L24.5,21.9z M16,24.5
                    c-6.1,0-10.4-3.2-13.6-8.3c1.9-3,4.1-5.3,6.8-6.7l2,2c-1.2,1.2-1.9,2.9-1.9,4.7c0,3.7,3,6.7,6.7,6.7c1.8,0,3.5-0.7,4.7-1.9l2,2
                    C20.7,23.9,18.5,24.5,16,24.5z" />
            </svg>
            <svg v-else version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32"
                overflow="visible" xml:space="preserve">
                <path d="M16,9.4c-3.7,0-6.7,3-6.7,6.7s3,6.7,6.7,6.7s6.7-3,6.7-6.7S19.7,9.4,16,9.4z M13.6,16.1c-1.3,0-2.3-1.1-2.3-2.3
                    c0-1.3,1.1-2.3,2.3-2.3c1.3,0,2.3,1.1,2.3,2.3C16,15,14.9,16.1,13.6,16.1z" />
                <path d="M31.4,15.7C27.9,9.8,22.9,6.1,16,6.1S4.1,9.8,0.6,15.7c-0.2,0.3-0.2,0.6,0,0.9c3.5,5.9,8.5,9.6,15.4,9.6s11.9-3.7,15.4-9.6
                    l0,0C31.5,16.3,31.5,16,31.4,15.7z M16,24.5c-6.1,0-10.4-3.2-13.6-8.3C5.6,11,9.9,7.8,16,7.8s10.4,3.2,13.6,8.3
                    C26.4,21.3,22.1,24.5,16,24.5z" />
            </svg>
        </div>
    </transition>
</div>
</template>

<script>
import { ref, computed, nextTick } from 'vue'
export default {
    name: 'InputShowPassword',
    inheritAttrs: false,
    props: ['modelValue', 'i18n'],
    setup ( props, context ) {

        const emit = context.emit

        let inputFieldRef = ref(null),
            showIcon      = ref(false),
            revealPass    = ref(false)

        const getInputType = computed(() => {
            return revealPass.value ? "text" : "password"
        })
        const getIconCls = computed(() => {
            return revealPass.value ? "icon-reveal icon-reveal--active" : "icon-reveal"
        })
        const getIconTitle = computed(() => {
            if (props && 'i18n' in props && typeof props.i18n == 'function') {
                return props.i18n(revealPass.value ? 'hide_pass' : 'show_pass')
            } else {
                return revealPass.value ? 'Hide password' : 'Show password'
            }
        })
        const onFieldInput = function (evt) {
            if ('inputType' in evt) {
                showIcon.value = (evt.target.value.length > 0)
            }
            emit('update:modelValue', evt.target.value)
        }
        const onFieldBlur = function (evt) {
            if (evt.target.value.length == 0) {
                revealPass.value = false
            }
            emit('blur', evt)
        }
        const onReveal = async function () {
            revealPass.value = !revealPass.value
            await nextTick()
            inputFieldRef.value.focus()
        }

        return {
            inputFieldRef,
            showIcon,
            revealPass,
            getInputType,
            getIconCls,
            getIconTitle,
            onFieldInput,
            onFieldBlur,
            onReveal,
            emit
        }
    }
}
</script>

<style lang="scss" scoped>
.input-password {
    position: relative;

    input {
        padding-right: 12%;
    }

    .icon-reveal {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 12%;
        max-width: 64px;
        height: 100%;
        cursor: pointer;
        z-index: 10;
    }

    svg {
        width: 50%;
        max-height: 26px;
    }
    svg path {
        fill: #5f5f5f;
    }
}
</style>